import z from "zod";

import { TransactionSchema } from "../../shared/transaction-schema";

export const RefundAcknowledgedSchema = z.object({
	action: z.literal("refund"),
	requestId: z.string().optional(),
	data: z.object({
		sessionUuid: z.string(),
		state: z.literal("ACKNOWLEDGED"),
	}),
	error: z
		.object({
			type: z.string(),
			message: z.string(),
		})
		.nullable()
		.optional(),
});

export type RefundAcknowledged = z.infer<typeof RefundAcknowledgedSchema>;

export const RefundTerminalBusySchema = z.object({
	action: z.literal("refund"),
	data: z.object({
		sessionUuid: z.string(),
		status: z.literal("TERMINAL_BUSY"),
	}),
	error: z
		.object({
			type: z.string(),
			message: z.string(),
		})
		.nullable()
		.optional(),
});

export type RefundTerminalBusy = z.infer<typeof RefundTerminalBusySchema>;

export const RefundResponseSchema = z.object({
	action: z.literal("refund"),
	requestId: z.string().optional(),
	data: z
		.object({
			status: z.union([
				z.literal("APPROVED"),
				z.literal("DECLINED"),
				z.literal("FAILED"),
			]),
		})
		.merge(TransactionSchema),
	error: z
		.object({
			type: z.string(),
			message: z.string(),
		})
		.nullable()
		.optional(),
});

export type RefundResponse = z.infer<typeof RefundResponseSchema>;

export const RefundSignatureVerificationSchema = z.object({
	action: z.literal("signatureVerification"),
	requestId: z.string().optional(),
	data: z.object({
		sessionUuid: z.string(),
		signature: z.string().optional(),
		state: z.union([
			z.literal("AWAITING_SIGNATURE"),
			z.literal("SIGNATURE_CLEARED"),
			z.literal("SIGNATURE_SUBMITTED"),
		]),
	}),
	error: z
		.object({
			type: z.string(),
			message: z.string(),
		})
		.nullable()
		.optional(),
});

export type RefundSignatureVerification = z.infer<
	typeof RefundSignatureVerificationSchema
>;

export const RefundTransactionEventSchema = z.object({
	action: z.literal("transactionEvent"),
	data: z.object({
		displayMessage: z.string().optional(),
		event: z.union([
			z.literal("AWAITING_ACCOUNT_SELECTION"),
			z.literal("AWAITING_APPLICATION_SELECTION"),
			// z.literal("AWAITING_PAYMENT_METHOD"), // Currently unhandled.
			z.literal("AWAITING_PIN_ENTRY"),
			z.literal("DISPLAYING_PAYMENT_MESSAGE"),
			z.literal("PROCESSING"),
			z.literal("RETRYING_PAYMENT_METHOD"),
		]),
		sessionUuid: z.string(),
	}),
	error: z
		.object({
			type: z.string(),
			message: z.string(),
		})
		.nullable()
		.optional(),
});

export type RefundTransactionEvent = z.infer<
	typeof RefundTransactionEventSchema
>;
